import { render } from "./InputformsRedirect.vue?vue&type=template&id=8c209688&scoped=true"
import script from "./InputformsRedirect.vue?vue&type=script&lang=js"
export * from "./InputformsRedirect.vue?vue&type=script&lang=js"

import "./InputformsRedirect.vue?vue&type=style&index=0&id=8c209688&scoped=true&lang=css"

import exportComponent from "/home/hakii/application-form-proto-admin-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c209688"]])

export default __exports__